export const getIsSupportTemplate = () => {
  return 'content' in document.createElement('template');
};

export const getFirstElementOfTemplate = (templateElement: HTMLTemplateElement): Element => {
  if (templateElement) {
    if (getIsSupportTemplate()) {
      return templateElement.content.firstElementChild;
    } else {
      return templateElement.firstElementChild;
    }
  }
  return null;
};
